import I18n from 'translations/i18n'

export const messages = {
  late_in: I18n.t('no_delay_was_recorded_for_this_shift'),
  early_out: I18n.t('no_shortage_was_recorded_for_this_shift'),
}

export const recordTitles = {
  late_in: I18n.t('recorded_clock_in'),
  early_out: I18n.t('recorded_clock_out'),
}
